// extracted by mini-css-extract-plugin
export var textInput = "_iu-0";